/**
 * LocationDisabledIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const LocationDisabledIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M9.07 11.161a3 3 0 1 1 4.2-4.2l2.8-2.86a7 7 0 0 0-12 4.86 12.5 12.5 0 0 0 1.7 5.47zm11.19-6.98a1 1 0 0 0-1.41 0L3.29 19.741a1 1 0 1 0 1.42 1.41l3.21-3.19c.91 1.3 1.78 2.4 2.38 3.12a1 1 0 0 0 1.54 0c1.82-2.21 6.23-7.95 6.23-12.12a8 8 0 0 0-.09-1.08l2.28-2.28a1 1 0 0 0 0-1.42" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const LocationDisabledIcon = makeIcon('LocationDisabledIcon', LocationDisabledIconSvg)
